import { lazy } from "react";
import { FeatureFlagRoute } from "../../_features/featureFlags/routing/FeatureFlagRoute";
import PermissionRoute from "./PermissionRoute";
import { ROUTE_PERMISSIONS } from "./routePermissions";

const Markets = lazy(() => import("../../_features/markets/pages/MarketsPage"));
const MarketDetails = lazy(() => import("../../_features/markets/pages/MarketDetailsPage"));
const Plans = lazy(() => import("../../_features/plans/pages/PlanPage"));
const ManagePlan = lazy(() => import("../../_features/plans/pages/PlanManagePage"));
const ProductsAndAddOns = lazy(() => import("../../_features/products/pages/ProductPage"));
const ManageProduct = lazy(() => import("../../_features/products/pages/ProductManagePage"));
const Events = lazy(() => import("../../_features/events/pages/EventsPage"));

export const configureRoutes = [
    {
        path: "/configure/market", element:
            <FeatureFlagRoute feature="markets">
                <PermissionRoute permission={ROUTE_PERMISSIONS.markets.view} moduleName="Markets"><Markets /></PermissionRoute>
            </FeatureFlagRoute>
    },
    {
        path: "/configure/market/:id", element:
            <FeatureFlagRoute feature="markets">
                <PermissionRoute permission={ROUTE_PERMISSIONS.markets.view} moduleName="Markets"><MarketDetails /></PermissionRoute>
            </FeatureFlagRoute>
    },
    {
        path: "/configure/plans", element:
            <FeatureFlagRoute feature="plans">
                <PermissionRoute permission={ROUTE_PERMISSIONS.plans.view} moduleName="Plans"><Plans /></PermissionRoute>
            </FeatureFlagRoute>
    },
    {
        path: "/configure/plans/create", element:
            <FeatureFlagRoute feature="plans">
                <PermissionRoute permission={ROUTE_PERMISSIONS.plans.create} moduleName="Plans"><ManagePlan /></PermissionRoute>
            </FeatureFlagRoute>
    },
    {
        path: "/configure/plans/:slug", element:
            <FeatureFlagRoute feature="plans">
                <PermissionRoute permission={ROUTE_PERMISSIONS.plans.edit} moduleName="Plans"><ManagePlan /></PermissionRoute>
            </FeatureFlagRoute>
    },
    {
        path: "/configure/products", element:
            <FeatureFlagRoute feature="productsAddOns">
                <PermissionRoute permission={ROUTE_PERMISSIONS.products.view} moduleName="Products"><ProductsAndAddOns /></PermissionRoute>
            </FeatureFlagRoute>
    },
    {
        path: "/configure/products/create", element:
            <FeatureFlagRoute feature="productsAddOns">
                <PermissionRoute permission={ROUTE_PERMISSIONS.products.create} moduleName="Products"><ManageProduct /></PermissionRoute>
            </FeatureFlagRoute>
    },
    {
        path: "/configure/products/:slug", element:
            <FeatureFlagRoute feature="productsAddOns">
                <PermissionRoute permission={ROUTE_PERMISSIONS.products.edit} moduleName="Products"><ManageProduct /></PermissionRoute>
            </FeatureFlagRoute>
    },
    {
        // Not permission-gated: no "event" module exists in the backend
        // permission catalog - see routePermissions.js's trailing comment.
        path: "/configure/events", element:
            <FeatureFlagRoute feature="events"><Events /></FeatureFlagRoute>
    }
];
